import { Card } from '@components/Card/Card.styled';
import styled, { css } from 'styled-components';

export const applyTheme = (_themeType: string) => {
    switch (_themeType) {
        case 'solidblue':
            return css`
                border-left: 9px solid #0a4a8d;
            `;
        case 'lightblue':
            return css`
                border-left: 9px solid #9ddcf9;
            `;
        case 'lightbluewithbg':
            return css`
                border-left: 9px solid #9ddcf9;
                background-color: #eff9fe;
            `;
        case 'grey':
            return css`
                border-left: 9px solid #d1d3d4;
            `;
        default:
            return css`
                border-left: 9px solid #d1d3d4;
            `;
    }
};

export const NewCardWrapper = styled(Card)<any>`
    padding: 20px;
    height: fit-content;
    min-width: fit-content;

    ${({ themeType }) => themeType && applyTheme(themeType)}

    @media screen and (max-width: 992px) {
        img {
            display: none;
        }
    }
`;
export const NotificationCardWrapper = styled(Card)`
    margin-bottom: 20px;
    display: block;
    align-self: flex-start;
    min-height: 0;
`;
